import Parser from 'html-react-parser';

export const HTMLParser = (string) => {
  if (typeof string !== 'string') {
    throw new Error('First argument must be a string');
  }
  return Parser(string);
};
